import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../ScrollToTop';
import MobileBottomNav from './MobileBottomNav';
import GuidanceBanner from './GuidanceBanner';
import { LeadProvider } from '../../context/LeadContext';

const Layout = () => {
  return (
    <LeadProvider>
    <div className="min-h-screen flex flex-col bg-gray-50 overflow-x-hidden">
      <Header />
      <GuidanceBanner />
      <main className="flex-grow container mx-auto px-4 py-8 pb-20 md:pb-8 overflow-x-hidden">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
      <MobileBottomNav />
    </div>
    </LeadProvider>
  );
};

export default Layout;

